"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const WelcomePopup_1 = require("@Components/Popups/WelcomePopup");
const contexts_1 = require("@App/contexts");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const MemberSummarySection_1 = __importDefault(require("@Scenes/HomeScene/MemberSummarySection"));
const SongwriterSummarySection_1 = __importDefault(require("@Scenes/HomeScene/SongwriterSummarySection"));
const MemberHeader_1 = __importDefault(require("@Scenes/HomeScene/MemberHeader"));
const SongwriterHeader_1 = __importDefault(require("@Scenes/HomeScene/SongwriterHeader"));
const HomeSceneWrapper_1 = __importDefault(require("@Components/HomeSceneWrapper"));
const HomeScene = (0, mobx_react_1.observer)(() => {
    const [welcomePopupIsOpen, setWelcomePopupIsOpen] = (0, react_1.useState)(false);
    const { userStore, uiStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const checkWelcomePopup = () => {
        const userSettings = userStore.userSettings;
        setWelcomePopupIsOpen(!(userSettings && 'showWelcomePopup' in userSettings && !userSettings.showWelcomePopup));
    };
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('home');
        userStore.loadUserSettings().then(() => {
            checkWelcomePopup();
        });
    }, []);
    const isMemberHome = uiStore.homePageState === 'member';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Home' }),
        react_1.default.createElement(HomeSceneWrapper_1.default, { header: isMemberHome ? react_1.default.createElement(MemberHeader_1.default, null) : react_1.default.createElement(SongwriterHeader_1.default, null), wrapperClass: isMemberHome ? 'member-home' : 'songwriter-home' }, isMemberHome ? react_1.default.createElement(MemberSummarySection_1.default, null) : react_1.default.createElement(SongwriterSummarySection_1.default, null)),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: welcomePopupIsOpen },
            react_1.default.createElement(WelcomePopup_1.WelcomePopup, { onClose: () => setWelcomePopupIsOpen(false) }))));
});
exports.default = HomeScene;
